import React from 'react';

interface Props {
  used: number;
  total: number;
}

const KvContextMeter: React.FC<Props> = ({ used, total }) => {
  const safeTotal = Math.max(1, total);
  const pct = Math.min(100, Math.round((used / safeTotal) * 100));
  const warn = pct >= 80;
  const label = used >= 1000 ? `${(used / 1000).toFixed(1)}k` : String(used);
  const totalLabel = total >= 1000 ? `${Math.round(total / 1000)}k` : String(total);
  return (
    <div
      className="kv-ctx-meter"
      data-warn={warn ? 'true' : 'false'}
      title={`Context window: ${used.toLocaleString()} / ${total.toLocaleString()} tokens`}
      aria-label={`Context window ${pct}% used`}
    >
      <span className="kv-ctx-meter__label">
        {label}<span className="kv-ctx-meter__sep">/</span>{totalLabel}
      </span>
      <span className="kv-ctx-meter__bar">
        <span
          className="kv-ctx-meter__fill"
          style={{ ['--p' as string]: `${pct}%` }}
        />
      </span>
    </div>
  );
};

export default KvContextMeter;
